function parseIntlNumber(input) {
    if (!input) return NaN;
    // Remove all characters except numeric, dot and comma
    input = input.trim().replace(/[^\d.,]/g, '');
    
    // both dot and comma are present
    if (input.indexOf(',') > -1 && input.indexOf('.') > -1) {
        // if comma is before dot, use dot as decimal separator e.g. 1,234.56 -> 1234.56
        if (input.indexOf(',') < input.indexOf('.')) {
            input = input.replace(',', '');
        } else {
            // if dot is before comma, use comma as decimal separator e.g. 1.234,56 -> 1234.56
            input = input.replace('.', '');
            input = input.replace(',', '.');
        }
    } else if (input.indexOf(',') > -1) {
        // only comma is present
        input = input.replace(',', '.');
    }
    
    try {
        return parseFloat(input);
    } catch (e) {
        return NaN;
    }
}

export { parseIntlNumber };